import { AccountFlagNames } from '@modules/userProfile/account/FeatureFlags';
import { useGetFeatureFlag } from '@src/app/shared/featureFlags/useGetFeatureFlag';
import { getShellConfig } from '@src/config/shell/config';
import { AuthenticationStore } from '@store/modules/data/authentication/authenticationIndex';
import { BooleanExperimentsSegment } from '@superbet-group/product.analytics';
import { Analytics as AnalyticsSdk } from '@superbet-group/web.analytics.sdk';
import { useVuexStore } from '@superbet-group/web.lib.vue-utilities';
import { computed } from '@vue/composition-api';
import {
    endOfDay,
    addDays,
} from 'date-fns';

const NEVER = new Date('2149-01-01');

export const usePE123Experiment = () => {
    const authModule = useVuexStore<AuthenticationStore>('data/authentication');

    const user = authModule.getter('user');

    const ftdDate = computed(() => {
        if (!user.value?.firstDepositDate || user.value?.firstDepositDate === true) {
            return null;
        }
        return new Date(user.value?.firstDepositDate);
    });
    const userFitsChallengeRequirements = computed(() => {
        if (!ftdDate.value || !user?.value) {
            return false;
        }

        const registrationDateThreshold = endOfDay(addDays(user?.value.registrationDate, 30));
        const isFtdWithinRegistrationThreshold = ftdDate.value < registrationDateThreshold;

        const ftdDateThreshold = endOfDay(addDays(ftdDate.value, 10));

        return isFtdWithinRegistrationThreshold && new Date() < registrationDateThreshold || new Date() < ftdDateThreshold;
    });

    const [isChallengeFlagEnabled, onChangeFlag] = useGetFeatureFlag<boolean | undefined>(AccountFlagNames.isPE123OnboardingChallengeEnabled, undefined);

    onChangeFlag((isEnabled) => {
        const startDate
            = getShellConfig().remoteConfig.experiments?.onboardingChallengeExperimentStartDate
            ?? NEVER;
        const ftdAfterExperimentEnabled = startDate < new Date();

        if (userFitsChallengeRequirements.value && ftdAfterExperimentEnabled && isEnabled !== undefined) {
            AnalyticsSdk.getInstance().log('PE123_Onboarding_Challenge_Segment', {
                group:
                    isEnabled
                        ? BooleanExperimentsSegment.A
                        : BooleanExperimentsSegment.B,
            });
        }
    });

    return computed(() => userFitsChallengeRequirements.value && !!isChallengeFlagEnabled.value);
};
